import { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import apiClient from "../utils/axiosConfig";
import { invalidateLookup } from "../utils/lookupCache";
import { useAuth } from "../dataContext/AuthContext";
import { GatewayDataContext } from "../dataContext/GatewayDataContext";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

/**
 * Single logout path for the app.
 * The server call is best-effort: local session state is always cleared afterwards,
 * so a failed/expired request can never leave the user stuck "logged in".
 */
export function useLogout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { setIsAuthenticated } = useContext(GatewayDataContext);

  return useCallback(async () => {
    try {
      await apiClient.post(`${apiBaseUrl}/Auth/logout`);
    } catch (error) {
      console.error("Logout request failed; clearing local session anyway", error);
    } finally {
      logout();
      invalidateLookup();
      localStorage.removeItem("isAuthenticated");
      Cookies.remove("refreshToken", { path: "/" });
      setIsAuthenticated(false);
      navigate("/login", { replace: true });
    }
  }, [logout, navigate, setIsAuthenticated]);
}
